module.exports = {"150727100":"阿拉坦额莫勒镇","150727101":"阿日哈沙特镇","150727102":"呼伦镇","150727200":"贝尔苏木","150727201":"克尔伦苏木","150727202":"达赉苏木","150727203":"宝格德乌拉苏木"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150727.json
// module id = 541
// module chunks = 0